<script>
	//@ts-nocheck
	import { onMount, onDestroy, tick } from 'svelte';
	// import * as d3 from 'd3';
	import election_results from '../../data/sabah2025.json';
	import geodata from '../../data/Sabah_districts_topo.json';

	import { feature } from 'topojson-client';
	import { geoPath, geoMercator } from 'd3-geo';
	import { format } from 'd3-format';
	import * as d3 from 'd3';

	import HorizontalBarchart from './HorizontalBarchart.svelte';
	import ElectionCardPanel from './ElectionCardPanel.svelte';
	import { getPartyColor } from '../utils/colors';

	export let house = 'districts';
	export let year = 2025;
	
	let container;
	let svgContainer;
	let containerWidth = 0;
	let width = 0;
	let height = 0;
	let svg;
	let refs = [];
	let selectedDistrict = null;
	let hoveredDistrict = null;
	
	let resizeObserver;
	let mapGroup;
	let isInitialized = false;
	let windowResizeHandler;
	
	// Store default projection parameters for reset
	let defaultScale = 7000;
	const defaultCenter = [117, 5.25];
	const defaultTranslate = [0, 0];
	
	// Detect mobile/tablet device (matching hamburger menu breakpoint at 1024px - Tailwind 'lg')
	$: isMobile = typeof window !== 'undefined' && window.innerWidth < 1024;
	
	// Mobile-specific adjustments: move center lower (south) and adjust scale for full extent
	$: mobileCenter = isMobile ? [117, 5.5] : defaultCenter; // Move south by decreasing latitude
	$: mobileScale = isMobile ? width * 11 : width * 12.2; // Slightly zoomed out on mobile for full extent
	
	// Maximum zoom level (minimum scale floor) - prevents zooming in too far on small constituencies
	// Set to 2.5x the default scale as a reasonable maximum
	$: maxScale = defaultScale * 3.5;
	
	// Current projection parameters
	let currentScale = 7000;
	let currentCenter = defaultCenter;
	let currentTranslate = defaultTranslate;
	let centerInitialized = false;
	
	// Initialize currentCenter with mobile-adjusted center on first load
	$: if (mobileCenter && !centerInitialized) {
		currentCenter = mobileCenter;
		centerInitialized = true;
	}
	
	// Make width fully responsive - use container width, with a minimum size
	// If containerWidth is 0, calculate a reasonable initial width
	$: width = (() => {
		if (containerWidth > 0) {
			return Math.max(containerWidth, 300);
		}
		// Fallback: use window width if available, otherwise default to 700
		if (typeof window !== 'undefined') {
			return Math.min(Math.max(window.innerWidth - 40, 300), 700);
		}
		return 700;
	})();
	$: height = width; // Keep height equal to width
	$: defaultScale = mobileScale; // Use mobile-adjusted scale
	
	// Initialize currentScale once when defaultScale is first calculated
	$: if (defaultScale && !isInitialized) {
		currentScale = defaultScale;
		isInitialized = true;
	}

	const updateContainerWidth = () => {
		// Prefer svgContainer, fallback to container
		const elementToMeasure = svgContainer || container;
		if (elementToMeasure) {
			const rect = elementToMeasure.getBoundingClientRect();
			let newWidth = rect.width;
			
			// If getBoundingClientRect returns 0, try computed style
			if (newWidth === 0) {
				const computedStyle = window.getComputedStyle(elementToMeasure);
				const computedWidth = parseFloat(computedStyle.width);
				if (!isNaN(computedWidth) && computedWidth > 0) {
					newWidth = computedWidth;
				}
			}
			
			// If still 0, try offsetWidth/clientWidth
			if (newWidth === 0) {
				newWidth = elementToMeasure.offsetWidth || elementToMeasure.clientWidth;
			}
			
			if (newWidth > 0) {
				containerWidth = newWidth;
			}
		}
	};

	onMount(async () => {
		if (typeof window !== 'undefined') {
			// Wait for DOM to be ready
			await tick();
			
			// Initial measurement
			updateContainerWidth();
			
			// If width is still 0, try multiple times with increasing delays
			// This handles cases where flexbox layout hasn't completed yet
			if (containerWidth === 0) {
				// Try after next frame
				requestAnimationFrame(() => {
					updateContainerWidth();
					// Try again after a short delay
					if (containerWidth === 0) {
						setTimeout(() => {
							updateContainerWidth();
							// Final attempt after layout should be complete
							if (containerWidth === 0) {
								setTimeout(updateContainerWidth, 200);
							}
						}, 50);
					}
				});
			}
			
			// Use ResizeObserver on the container
			const elementToObserve = svgContainer || container;
			if (elementToObserve) {
				resizeObserver = new ResizeObserver(entries => {
					for (let entry of entries) {
						const newWidth = entry.contentRect.width;
						if (newWidth > 0) {
							containerWidth = newWidth;
						}
					}
				});
				
				resizeObserver.observe(elementToObserve);
			}
			
			// Also handle window resize as a fallback
			windowResizeHandler = () => {
				updateContainerWidth();
			};
			
			window.addEventListener('resize', windowResizeHandler);
		}
	});
	
	onDestroy(() => {
		if (resizeObserver) {
			resizeObserver.disconnect();
		}
		if (windowResizeHandler) {
			window.removeEventListener('resize', windowResizeHandler);
		}
	});

	const colors = {
		"Gabungan Rakyat Sabah": "#4682B4",
		"United Malays National Organisation": "#C00000",
		"Malaysian United Indigenous Party": "#E62020",
		"United Sabah Party": "#ADD8E6",
		"Homeland Solidarity Party": "#78D7F5",
		"Parti Bersatu Rakyat Sabah": "#FEDF00",
		"Malaysian Chinese Association": "#102a7e",
		"Sabah Progressive Party": "#F8F6BC",

		"Warisan Plus": "#ED1C24",
		"Sabah Heritage Party": "#A4E5FC",
		"Democratic Action Party": "#ED1C24",
		"People's Justice Party": "#00ADEF",
		"United Progressive Kinabalu Organisation": "#ABCDFF",
		"National Trust Party": "#FFA009",

		"Love Sabah Party": "#FB5B47",
		"Liberal Democratic Party": "#FF7F00",
		"United Sabah National Organisation (New)": "#678F43",
		"Sabah People's Hope Party": "#6F92C0",
		"Parti Gagasan Rakyat Sabah": "#8f00ff",
		"Sabah People's Unity Party": "#FFCD00",
		"Sabah Native Co-operation Party": "#F49950",
		"Sabah Nationality Party": "#599E59",
		"Independents": "#DCDCDC",

		"Parti Bersatu Sabah": '#FEDF00',
		"Parti Cinta Sabah": '#FB5B47',
		"Perikatan Nasional": '#002D52',
		"PKS": '#00ADEF',
		"PPRS": '#FFCD00',
		"United Sabah National Organisation": "#678F43",
		"Warisan Plus (duplicate)": "#ED1C24",
		"Barisan Nasional": '#020080',
		"HR": '#000000',
		"ANAK NEGERI": 'orange',

		"map-outline": "#000000",
		"Independent": "#DCDCDC"
	};

	$: prepBarChartData = () => {
		// List of independent symbols that should be grouped as BEBAS
		const independentSymbols = [
			'ARNAB', 'BAJU', 'BUKU', 'CEREK', 'CINCIN', 'GAJAH', 'JAM',
			'KERUSI', 'KUDA', 'KUNCI', 'MANGGIS', 'PEN', 'POKOK', 'RUMAH',
			'TRAKTOR', 'UDANG'
		];
		
		// Helper function to check if a result is Bebas/Independent
		const isBebas = (r) => {
			if (!r) return false;
			// Check if party_name_pretty_en starts with "BEBAS"
			if (r.party_name_pretty_en && r.party_name_pretty_en.toUpperCase().startsWith('BEBAS')) {
				return true;
			}
			// Check if party_acronym_en is an independent symbol
			if (r.party_acronym_en && independentSymbols.includes(r.party_acronym_en.toUpperCase())) {
				return true;
			}
			return false;
		};
		
		// Tally seats won by each party
		const tally = {};
		filteredResults.forEach((r) => {
			// Filter out empty results and ensure result is 'winner'
			if (r.result && r.result !== '' && r.result === 'winner') {
				// Group all Bebas winners together
				if (isBebas(r)) {
					tally['(BEBAS)'] = (tally['(BEBAS)'] || 0) + 1;
				} else {
					const party = r.party_name_pretty_en;
					if (party) {
						tally[party] = (tally[party] || 0) + 1;
					}
				}
			}
		});
		const entries = Object.entries(tally)
			.map(([category, value]) => {
				// Find the corresponding result to get party_acronym_en
				let result;
				if (category === '(BEBAS)') {
					// Find any Bebas winner for color
					result = filteredResults.find((r) => isBebas(r) && r.result === 'winner');
				} else {
					result = filteredResults.find((r) => r.party_name_pretty_en === category && r.result === 'winner');
				}
				// Use getPartyColor with the result object (which has party_acronym_en)
				return {
					category, 
					value, 
					color: getPartyColor(result || '', true).fill 
				};
			})
			.sort((a, b) => b.value - a.value);
		// Return empty array if no valid results, or return entries
		return entries.length > 0 ? entries : [];
	}

	$: topParties = prepBarChartData();

	$: console.log('topParties', topParties)


	$: getColor = (result, justParty = false, pcode = null) => {
		// console.log('result', result);
		// console.log('justParty', justParty);
		if (justParty) {
			// If result is a string, use it directly; otherwise use party_acronym_en
			const partyAcronym = typeof result === 'string' ? result : (result?.party_acronym_en || result?.party_name_pretty_en || '');
			return getPartyColor(partyAcronym || result, true);
		}
		// Handle empty or missing result arrays
		if (!result || !Array.isArray(result) || result.length === 0) {
			return {
				fill: '#808080', // Gray for missing data
				opacity: 0.7
			};
		}
		let winner = result.find((r) => r.result === 'winner' && r.result !== '');
		// If no winner found, return gray
		if (!winner) {
			return {
				fill: '#808080', // Gray for missing data
				opacity: 0.7
			};
		}

		let isHighlighted = selectedDistrict ? winner?.pcode === selectedDistrict : true;
		let isHovered = hoveredDistrict ? pcode === hoveredDistrict : false;

		// Use getPartyColor with party_acronym_en
		const colorResult = getPartyColor(winner, true);
		
		return {
			fill: colorResult.fill,
			opacity: getOpacity(winner?.votes_share, isHighlighted, isHovered)
		};
	};
	const getOpacity = (voteShare, highlight, isHovered) => {
		// Handle undefined/null voteShare
		if (voteShare === undefined || voteShare === null || voteShare === '') {
			return 0.7;
		}
		// If hovering, show full opacity for hovered feature, low for others
		if (hoveredDistrict !== null) {
			return isHovered ? 1.0 : 0.2;
		}
		// Default opacity when not hovering
		return 0.7;
	};

	// Get stroke properties for path elements based on selection state
	$: getStrokeProps = (pcode) => {
		const isSelected = selectedDistrict && pcode === selectedDistrict;
		return {
			stroke: isSelected ? '#FFD700' : colors['map-outline'], // Gold highlight for selected
			strokeWidth: isSelected ? '2.5' : '0.5',
			strokeOpacity: isSelected ? '1' : '1'
		};
	};

	$: filteredResults = election_results
		.filter((r) => String(r.election_date_year) === String(year))
		.filter(
			(r) =>
				(r.hluttaw_type_en === 'Sabah State Legislative Assembly')
		);

	$: geographies = {
		districts: feature(geodata, geodata.objects.Sabah_districts).features.map((d) => {
			const result = filteredResults.filter((r) => r.pcode.split('_')[1] === d.properties.code_dun);
			return {
				...d,
				properties: {
					...d.properties,
					result: result
				}
			};
		})
	};

	$: projection = geoMercator()
		.scale(currentScale)
		.center(currentCenter)
		.translate([width / 2 + currentTranslate[0], height / 2 + currentTranslate[1]]);

	const zoomToFeature = (geography) => {
		if (!geography || !svg || !mapGroup) return;
		
		// Store current projection state
		const startProjection = geoMercator()
			.scale(currentScale)
			.center(currentCenter)
			.translate([width / 2 + currentTranslate[0], height / 2 + currentTranslate[1]]);
		
		// Create target projection
		const targetProjection = geoMercator()
			.translate([width / 2, height / 2]);
		
		// Fit the feature with padding (10% on each side)
		const padding = Math.min(width, height) * 0.1;
		targetProjection.fitSize([width - padding * 2, height - padding * 2], geography);
		
		// Get the new projection parameters
		let newScale = targetProjection.scale();
		let newCenter = targetProjection.center();
		let newTranslate = [
			targetProjection.translate()[0] - width / 2,
			targetProjection.translate()[1] - height / 2
		];
		
		// Clamp scale to maximum zoom level (minimum scale floor)
		if (newScale > maxScale) {
			newScale = maxScale;
			// Center on the geography's centroid at the maximum zoom level
			const centroid = d3.geoCentroid(geography);
			const maxZoomProjection = geoMercator()
				.scale(newScale)
				.center(centroid)
				.translate([width / 2, height / 2]);
			
			newCenter = maxZoomProjection.center();
			newTranslate = [
				maxZoomProjection.translate()[0] - width / 2,
				maxZoomProjection.translate()[1] - height / 2
			];
		}
		
		// Create path generators for start and end states
		const startPath = geoPath().projection(startProjection);
		const targetPath = geoPath().projection(targetProjection);
		
		// Create transition
		if (mapGroup) {
			const t = d3.transition()
				.duration(750)
				.ease(d3.easeCubicInOut);
			
			// Transition each path's d attribute directly
			const paths = d3.select(mapGroup).selectAll('path');
			
			paths.transition(t)
				.attrTween('d', function(d) {
					const startD = startPath(d);
					const targetD = targetPath(d);
					return d3.interpolateString(startD || '', targetD || '');
				})
				.on('end', function() {
					// Update reactive variables after transition completes
					currentScale = newScale;
					currentCenter = newCenter;
					currentTranslate = newTranslate;
				});
		}
	};
	
	const resetZoom = () => {
		if (!mapGroup) return;
		
		// Store current projection state
		const startProjection = geoMercator()
			.scale(currentScale)
			.center(currentCenter)
			.translate([width / 2 + currentTranslate[0], height / 2 + currentTranslate[1]]);
		
		// Create target projection
		const targetProjection = geoMercator()
			.scale(defaultScale)
			.center(mobileCenter)
			.translate([width / 2 + defaultTranslate[0], height / 2 + defaultTranslate[1]]);
		
		// Create path generators for start and end states
		const startPath = geoPath().projection(startProjection);
		const targetPath = geoPath().projection(targetProjection);
		
		const t = d3.transition()
			.duration(750)
			.ease(d3.easeCubicInOut);
		
		// Transition each path's d attribute directly
		const paths = d3.select(mapGroup).selectAll('path');
		
		paths.transition(t)
			.attrTween('d', function(d) {
				const startD = startPath(d);
				const targetD = targetPath(d);
				return d3.interpolateString(startD || '', targetD || '');
			})
			.on('end', function() {
				// Update reactive variables after transition completes
				currentScale = defaultScale;
				currentCenter = mobileCenter;
				currentTranslate = defaultTranslate;
			});
	};
	
	const zoomIn = () => {
		if (!mapGroup) return;
		
		const newScale = Math.min(currentScale * 1.5, maxScale);
		
		// Store current projection state
		const startProjection = geoMercator()
			.scale(currentScale)
			.center(currentCenter)
			.translate([width / 2 + currentTranslate[0], height / 2 + currentTranslate[1]]);
		
		// Create target projection
		const targetProjection = geoMercator()
			.scale(newScale)
			.center(currentCenter)
			.translate([width / 2 + currentTranslate[0], height / 2 + currentTranslate[1]]);
		
		// Create path generators for start and end states
		const startPath = geoPath().projection(startProjection);
		const targetPath = geoPath().projection(targetProjection);
		
		const t = d3.transition()
			.duration(300)
			.ease(d3.easeCubicInOut);
		
		// Transition each path's d attribute directly
		const paths = d3.select(mapGroup).selectAll('path');
		
		paths.transition(t)
			.attrTween('d', function(d) {
				const startD = startPath(d);
				const targetD = targetPath(d);
				return d3.interpolateString(startD || '', targetD || '');
			})
			.on('end', function() {
				// Update reactive variables after transition completes
				currentScale = newScale;
			});
	};
	
	const zoomOut = () => {
		if (!mapGroup) return;
		
		const newScale = Math.max(currentScale / 1.5, defaultScale * 0.1); // Don't zoom out too far
		
		// Store current projection state
		const startProjection = geoMercator()
			.scale(currentScale)
			.center(currentCenter)
			.translate([width / 2 + currentTranslate[0], height / 2 + currentTranslate[1]]);
		
		// Create target projection
		const targetProjection = geoMercator()
			.scale(newScale)
			.center(currentCenter)
			.translate([width / 2 + currentTranslate[0], height / 2 + currentTranslate[1]]);
		
		// Create path generators for start and end states
		const startPath = geoPath().projection(startProjection);
		const targetPath = geoPath().projection(targetProjection);
		
		const t = d3.transition()
			.duration(300)
			.ease(d3.easeCubicInOut);
		
		// Transition each path's d attribute directly
		const paths = d3.select(mapGroup).selectAll('path');
		
		paths.transition(t)
			.attrTween('d', function(d) {
				const startD = startPath(d);
				const targetD = targetPath(d);
				return d3.interpolateString(startD || '', targetD || '');
			})
			.on('end', function() {
				// Update reactive variables after transition completes
				currentScale = newScale;
			});
	};

	$: onRegionClick = (results, index, geography) => {
		if (!results?.result) {
			selectedDistrict = null;
			resetZoom();
			return;
		}

		selectedDistrict = results.result[0]?.pcode;
		
		// Find the corresponding geography and zoom to it
		if (geography) {
			zoomToFeature(geography);
		}
	};

	const onCardClick = (pcode) => {
		selectedDistrict = pcode;
		
		// Find the geography that matches this pcode and zoom to it
		if (geographies && geographies[house]) {
			const matchingGeography = geographies[house].find(g => {
				const winner = g.properties.result?.find((r) => r.result && r.result !== '' && r.result === 'winner');
				return winner?.pcode === pcode;
			});
			
			if (matchingGeography) {
				zoomToFeature(matchingGeography);
			}
		}
	};

  $: getOthersShare = (results) => {
		console.log(results)
    return Math.round(100 - results.reduce((acc, curr) => {
			if (curr.result === 'other') {
				return acc
			} else {
				return acc  + curr.votes_share
			}
		}, 0), 0);
  };


	$: console.log(geographies)
	// $: console.log(filteredResults)
	// 	$: console.log(hoveredResult);
	//
</script>

<div class="flex flex-col gap-4 h-full election-container lg:flex-row">
	<!-- Map Section -->
	<div class="flex flex-col flex-1 justify-center items-center map-section" bind:this={container}>
		<div class="w-full max-w-full barchart-container">
			<HorizontalBarchart data={prepBarChartData()} width={width} title="Seats Won" formatNumber={(d) => format('.0f')(d)}/>
		</div>
		<div class="flex flex-row flex-wrap gap-4 justify-center mt-2">
			{#each topParties as party}
				<div class="flex items-center text-sm">
					<div 
						class="inline-block mr-1 w-4 h-4 rounded-full"
						style="background-color: {party.color};"
					></div>
					<span>{party.category.match(/\(([^)]+)\)/)?.[1] || party.category}</span>
				</div>
			{/each}
		</div>
		
		<div class="relative w-full svg-container" style="max-width: 100%;" bind:this={svgContainer}>
			<!-- Zoom Controls -->
			<div class="flex overflow-hidden absolute top-2 right-2 z-10 flex-col gap-1 bg-white rounded-lg border border-gray-200 shadow-lg">
				<button
					on:click={zoomIn}
					class="p-2 transition-colors hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500"
					aria-label="Zoom in"
					title="Zoom in"
				>
					<svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
						<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
					</svg>
				</button>
				<div class="border-t border-gray-200"></div>
				<button
					on:click={zoomOut}
					class="p-2 transition-colors hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500"
					aria-label="Zoom out"
					title="Zoom out"
				>
					<svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
						<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 12H4" />
					</svg>
				</button>
				<div class="border-t border-gray-200"></div>
				<button
					on:click={resetZoom}
					class="p-2 transition-colors hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500"
					aria-label="Reset zoom"
					title="Reset zoom"
				>
					<svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
						<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
					</svg>
				</button>
			</div>
			
			<svg width={width} height={height} bind:this={svg}
				on:click={(e) => {
					// Only reset if clicking directly on SVG background (not on a path)
					if (e.target === svg || e.target.tagName === 'g') {
						selectedDistrict = null;
						resetZoom();
					}
				}}
			>
				<g bind:this={mapGroup}>
					{#each geographies[house] as geography, index}
						{@const winner = geography.properties.result?.find((r) => r.result && r.result !== '' && r.result === 'winner')}
						{@const pcode = winner?.pcode}
						<!-- svelte-ignore a11y-no-static-element-interactions -->
						<!-- svelte-ignore a11y-mouse-events-have-key-events -->
						<path
							id={geography.id}
							d={geoPath().projection(projection)(geography)}
							fill={getColor(geography.properties.result, false, pcode).fill}
							stroke={getStrokeProps(pcode).stroke}
							stroke-opacity={getStrokeProps(pcode).strokeOpacity}
							stroke-width={getStrokeProps(pcode).strokeWidth}
							opacity={getColor(geography.properties.result, false, pcode).opacity}
							bind:this={refs[index]}
							class="cursor-pointer"
						tabindex="0"
						role="button"
						on:mouseenter={() => {
							if (pcode) {
								hoveredDistrict = pcode;
							}
						}}
						on:mouseleave={() => {
							hoveredDistrict = null;
						}}
						on:click={(e) => {
							e.stopPropagation();
							onRegionClick({ result: geography.properties.result }, index, geography);
						}}
						on:keydown={(e) => {
							if (e.key === 'Enter' || e.key === ' ') {
								e.preventDefault();
								onRegionClick({ result: geography.properties.result }, index, geography);
							}
						}}
						/>
					{/each}
				</g>
			</svg>
		</div>
	</div>

	
	
	<!-- Card Panel -->
	<div class="w-full card-panel lg:w-[480px] lg:h-full">
		<ElectionCardPanel 
			districts={geographies[house]} 
			selectedPcode={selectedDistrict}
			hoveredPcode={hoveredDistrict}
			{onCardClick}
		/>
	</div>
</div>

<style>
	.svg-container {
		width: 100%;
		max-width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	
	.barchart-container {
		width: 100%;
		max-width: 100%;
		overflow: hidden;
	}
	
	.barchart-container :global(svg) {
		width: 100%;
		max-width: 100%;
		height: auto;
	}
	
	svg {
		display: block;
		margin: auto;
		max-width: 100%;
		height: auto;
	}
	
	svg path {
		outline: none;
	}
	
	svg path:focus {
		outline: none;
	}
	
	.election-container {
		min-height: 100vh;
		width: 100%;
		overflow: hidden;
	}
	
	.map-section {
		position: relative;
		width: 100%;
		padding: 0 1rem;
		flex: 1;
		min-width: 0; /* Allows flex item to shrink below content size */
	}
	
	.card-panel {
		height: 100vh;
		max-height: 100vh;
		display: flex;
		flex-direction: column;
		overflow: hidden;
		/* Fixed width on desktop, responsive on mobile */
		width: 100%;
	}
	
	/* Desktop: fixed width side panel, map takes remaining space (matching hamburger menu breakpoint) */
	@media (min-width: 1024px) {
		.election-container {
			display: flex;
			flex-direction: row;
		}
		
		.map-section {
			flex: 1 1 auto; /* Take up remaining space */
			min-width: 0;
			max-width: none;
		}
		
		.card-panel {
			width: 480px;
			min-width: 480px;
			max-width: 480px;
			flex-shrink: 0; /* Prevent shrinking */
		}
	}
	
	/* Mobile/Tablet adjustments (matching hamburger menu breakpoint) */
	@media (max-width: 1023px) {
		.election-container {
			min-height: auto;
		}
		
	.map-section {
		padding: 0 0.5rem;
		margin-top: 0.5rem;
	}
		
		.card-panel {
			height: 50vh;
			max-height: 50vh;
			width: 100%;
			min-width: 0;
			max-width: 100%;
		}
		
		.barchart-container {
			padding: 0;
		}
	}
</style>
